import api from '@/api/index'
import config from '@/config/index'
import {DROPDOWN_SUCCESS} from '../types'
const state = {
  pool: {},
  education: [{
    label: '大专',
    value: '01',
  },{
    label: '本科',
    value: '02',
  },{
    label: '硕士',
    value: '03',
  }, {
    label: '博士',
    value: '04',
  }],
  enrollType: [{
    label: '全部',
    value: ''
  }, {
    label: '线上课程报名',
    value: '01'
  }, {
    label: '直播预约报名',
    value: '02'
  }, {
    label: '培训计划报名',
    value: '03'
  }, {
    label: '线下课程报名',
    value: '04'
  }],
  publicState: [{
    label: '全员可见',
    value: '2'
  }, {
    label: '本机构',
    value: '3'
  }, {
    label: '无',
    value: '0'
  }],
  resourceType: [{
    label: '文档',
    value: '0'
  }, {
    label: '图片',
    value: '1'
  }, {
    label: '视频',
    value: '2'
  }, {
    label: '音频',
    value: '3'
  }],
  putOnOffType: [{
    label: '上架',
    value: '1'
  }, {
    label: '下架',
    value: '0'
  }],
  putOnOffType1: [{
    label: '上架',
    value: '0'
  }, {
    label: '下架',
    value: '1'
  }],
  visibleRangeType: [{
    label: '全员可见',
    value: '2'
  }, {
    label: '指定人员',
    value: '1'
  }, {
    label: '无',
    value: '0'
  }],
  timeState: [{
    label: '未开始',
    value: '1'
  }, {
    label: '进行中',
    value: '2'
  }, {
    label: '已结束',
    value: '3'
  }],
  largeType: [{
    label: '大分类1',
    value: '1'
  }, {
    label: '大分类2',
    value: '2'
  }, {
    label: '大分类3',
    value: '3'
  }],
  middleType: [{
    label: '小分类1',
    value: '11'
  }, {
    label: '小分类2',
    value: '22'
  }, {
    label: '小分类3',
    value: '33'
  }],
  level: [{
    label: '困难',
    value: '11'
  }, {
    label: '中等',
    value: '22'
  }, {
    label: '简单',
    value: '33'
  }],
  examPaperType: [{
    label: '试卷',
    value: '1'
  }, {
    label: '题组',
    value: '0'
  }],
  questionType: [{
    label: '单选题',
    value: 'selection'
  }, {
    label: '多选题',
    value: 'multiSelection'
  }, {
    label: '填空题',
    value: 'write'
  }, {
    label: '简答题',
    value: 'short'
  }, {
    label: '判断题',
    value: 'judgement'
  }]
}

const actions = {
  getAllDropdowns (store) {
    store.dispatch('getDropdowns', 'entMember')
    store.dispatch('getDropdowns', 'information_type')
    store.dispatch('getBusinessIds')
  },
  getBusinessIds (store) {
    api.post(config.bylApiPath, '/entBusiness/search', {}, function (r) { // 正常
      store.commit('DROPDOWN_SUCCESS', {type: 'businessIds', value: r.data})
      store.dispatch('localSave', {type: 'businessIds', value: r.data})
    })
  },
  getDropdowns (store, type) {
    api.get(config.bylBaseCenterPath, '/dict/findList', {
      type: type,
      pageNo: 1,
      pageSize: 100
    }, function (r) { // 正常
      console.log(r)
      store.commit('DROPDOWN_SUCCESS', {type: type, value: r.data})
      store.dispatch('localSave', {type: type, value: r.data})
    })
  },
  localSave (store, data) {
    var exist = JSON.parse(window.localStorage.getItem('pool')) || {}
    exist[data.type] = data
    window.localStorage.setItem('pool', JSON.stringify(exist))
  }
}
const mutations = {
  [DROPDOWN_SUCCESS] (state, action) {
    state.pool[action.type] = action.value
  }
}
const getters = {
  getPool: state => {
    return state.pool || {}
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/dropdowns.js